import {CycleStatusType, CycleTagType, ICycle, ICycleLog, ICyclePreferences, IMetaTagValue, IStation, ISubFile, MinimalUserModel, TriggerEntity} from '@core/api/data-access';
import {StoredFile} from '@global-data';

import {undefined} from 'zod';
import {StationModel} from '../station';

export class CycleModel implements ICycle {
	id = '';
	name = '';
	status: CycleStatusType = CycleStatusType.Draft;
	user: string;
	userModel: MinimalUserModel;

	enabled = true;
	archive = false;

	document = ''; // name of the document file in database
	stations: StationModel[] = [];
	tags: CycleTagType[] = [];
	triggers: TriggerEntity[] = [];
	log: ICycleLog[] = [];
	metaTags: IMetaTagValue[] = [];
	preferences: ICyclePreferences = {
		flatten: false,
	};

	erpId: string;
	subfiles?: ISubFile[] = [];
	lastUpdate: Date;

	constructor(init: Partial<CycleModel | ICycle>) {
		if (!init) return;
		Object.assign(this, init);
		if (init?.stations) {
			this.stations = init.stations.map((station: IStation) => new StationModel(station));
		}
		if (init.userModel) {
			this.userModel = new MinimalUserModel(init.userModel);
		}
	}

	toJSON(): ICycle {
		const json: Partial<ICycle> = {
			id: this.id,
			archive: this.archive,
			document: this.document,
			enabled: this.enabled,
			metaTags: this.metaTags,
			name: this.name,
			stations: this.stations?.map(station => station.toJSON()),
			tags: this.tags,
			triggers: this.triggers,
			user: this.user,
			subfiles: this.subfiles,
		};
		Object.keys(json).forEach((key: string) => {
			if (json[key] === undefined) delete json[key];
		});
		return json as ICycle;
	}
}

export type ICycleWithDocument = ICycle & {
	pdfDocument: StoredFile;
};
